import { httpClient } from '@/services/http/httpClient'

export async function deleteIdeaFieldTemplate(id: string): Promise<void> {
  await httpClient.delete(`/ideas/campaigns/field-templates/${id}`)
}
